export enum NonCompetitionRestrictionSlot {
    DistanceRadiusMiles = 0,
    DurationYearsFromClosing = 1,
    DurationYearsFromEmployment = 2,
}

export const NonCompetitionRestrictionSlotLabels: Record<NonCompetitionRestrictionSlot, string> = {
    [NonCompetitionRestrictionSlot.DistanceRadiusMiles]: 'Distance: Radius (miles)',
    [NonCompetitionRestrictionSlot.DurationYearsFromClosing]: 'Duration: Months from Closing',
    [NonCompetitionRestrictionSlot.DurationYearsFromEmployment]: 'Duration: Months from Employment',
};

export const NonCompetitionRestrictionSlotOptions: { value: NonCompetitionRestrictionSlot; label: string }[] = [
    { value: NonCompetitionRestrictionSlot.DistanceRadiusMiles, label: NonCompetitionRestrictionSlotLabels[NonCompetitionRestrictionSlot.DistanceRadiusMiles] },
    { value: NonCompetitionRestrictionSlot.DurationYearsFromClosing, label: NonCompetitionRestrictionSlotLabels[NonCompetitionRestrictionSlot.DurationYearsFromClosing] },
    { value: NonCompetitionRestrictionSlot.DurationYearsFromEmployment, label: NonCompetitionRestrictionSlotLabels[NonCompetitionRestrictionSlot.DurationYearsFromEmployment] },
];
